import DashboardLayout from "src/pages/Dashboard/Layout/DashboardLayout.vue";
import DashboarIndex from "src/pages/Dashboard/index.vue";
import AuthLayout from "src/pages/Dashboard/Pages/AuthLayout.vue";
import ChangePassLayout from "src/pages/Dashboard/Pages/ChangePasswordLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";

// Page Headers
import CalendarHeader from "src/pages/Dashboard/Calendar/CalendarHeader";
const DashboardHeader = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard/DashboardHeader.vue"
  );
import DefaultHeader from "src/pages/Dashboard/DefaultHeader";
import SweetAlertHeader from "src/pages/Dashboard/Components/Headers/SweetAlertHeader";
import VectorMapsHeader from "src/pages/Dashboard/Maps/VectorMapsHeader";

// Calendar
const Calendar = () =>
  import(
    /* webpackChunkName: "calendar" */ "src/pages/Dashboard/Calendar/CalendarRoute.vue"
  );
// Charts
const Charts = () =>
  import(/* webpackChunkName: "charts" */ "src/pages/Dashboard/Charts.vue");

// Components pages
const Buttons = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Buttons.vue"
  );
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/GridSystem.vue"
  );
const Panels = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Panels.vue"
  );
const SweetAlert = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/SweetAlert.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Notifications.vue"
  );
const Icons = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Icons.vue"
  );
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Dashboard/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/views/dashboard/DashboardMain.vue"
  );
import Widgets from "src/pages/Dashboard/Widgets.vue";

// Forms pages
const RegularForms = () => import("src/pages/Dashboard/Forms/RegularForms.vue");
const ExtendedForms = () =>
  import("src/pages/Dashboard/Forms/ExtendedForms.vue");
const ValidationForms = () =>
  import("src/pages/Dashboard/Forms/ValidationForms.vue");
const Wizard = () => import("src/pages/Dashboard/Forms/Wizard.vue");

// Maps pages
const GoogleMaps = () =>
  import(
    /* webpackChunkName: "maps" */ "src/pages/Dashboard/Maps/GoogleMaps.vue"
  );
const FullScreenMap = () =>
  import(
    /* webpackChunkName: "maps" */ "src/pages/Dashboard/Maps/FullScreenMap.vue"
  );
const VectorMaps = () =>
  import(
    /* webpackChunkName: "maps" */ "src/pages/Dashboard/Maps/VectorMaps.vue"
  );

// Pages
const User = () =>
  import(
    /* webpackChunkName: "pages" */ "src/pages/Dashboard/Pages/UserProfile.vue"
  );
const Pricing = () =>
  import(
    /* webpackChunkName: "pages" */ "src/pages/Dashboard/Pages/Pricing.vue"
  );
const TimeLine = () =>
  import(
    /* webpackChunkName: "pages" */ "src/pages/Dashboard/Pages/TimeLinePage.vue"
  );
const Login = () =>
  import(/* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Login.vue");
const Register = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Register.vue"
  );

const Registro = () =>
  import(
    /* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Registro.vue"
  );
const Lock = () =>
  import(/* webpackChunkName: "auth" */ "src/pages/Dashboard/Pages/Lock.vue");

// TableList pages
const RegularTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Dashboard/Tables/RegularTables.vue"
  );
const ExtendedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Dashboard/Tables/ExtendedTables.vue"
  );
const PaginatedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Dashboard/Tables/PaginatedTables.vue"
  );
const VistaPerfiles = () => import("src/pages/views/perfiles/perfiles.vue");

const VistaProspectos = () =>
  import("src/pages/views/prospectos/prospectos.vue");

const VistaLogout = () => import("src/pages/Dashboard/Pages/Logout.vue");

const VistaComunicados = () =>
  import("src/pages/views/comunicados/comunicados.vue");

const VistaUsuarios = () => import("src/pages/views/usuarios/usuario.vue");

const VistaUnidadMedida = () =>
  import("src/pages/views/catalogos/unidadMedida/unidadMedida.vue");

const VistaMonedas = () => import("src/pages/views/monedas/monedas.vue");

//
const VistaNotificaciones = () =>
  import("src/pages/views/notificaciones/notificaciones.vue");

const VistaCategoriaProducto = () =>
  import("src/pages/views/categoriaproducto/categoriaproducto.vue");

const VistaSubcategoriaProducto = () =>
  import("src/pages/views/subcategoriaproducto/subcategoriaproducto.vue");

const VistaReclamaciones = () =>
  import("src/pages/views/reclamaciones/reclamaciones.vue");
const VistaPedidos = () => import("src/pages/views/pedidos/pedidos.vue");

const VistaNuevoPedido = () => import("src/pages/views/pedidos/pedidosAdd.vue");

const VistaMailConfig = () =>
  import("src/pages/views/mailconfiguration/mailconfiguration.vue");
const VistaProductos = () =>
  import("src/pages/views/productos/ProductosMain.vue");

const VistaClientes = () => import("src/pages/views/clientes/clientes.vue");

const VistaTiposDocumentos = () =>
  import("src/pages/views/tiposDocumentos/tiposDocumentos.vue");

const VistaCaracteristicaProducto = () =>
  import("src/pages/views/productocaracteristica/productocaracteristica.vue");

const VistaMotivosDeclinacion = () =>
  import("src/pages/views/motivoDeclinacion/motivoDeclinacion.vue");

const VistaConfiguracionNotificaciones = () =>
  import(
    "src/pages/views/configuracionNotificaciones/configuracionNotificaciones.vue"
  );
const VistaHorarioIngreso = () =>
  import("src/pages/views/horarioIngreso/horarioIngreso.vue");

const VistaFamiliaProducto = () =>
  import("src/pages/views/familiaproducto/familiaproducto.vue");

const VistaNuevaFamiliaProducto = () =>
  import("src/pages/views/familiaproducto/familiaProductoAddEdit.vue");

const VistaPropiedadFamiliaProducto = () =>
  import(
    "src/pages/views/propiedadFamiliaProducto/propiedadFamiliaProducto.vue"
  );

const VistaPerfilesEmpresariales = () =>
  import("src/pages/views/perfilesEmpresariales/perfilEmpresarial.vue");

const VistaNuevoPerfilEmpresarial = () =>
  import("src/pages/views/perfilesEmpresariales/perfilEmpresarialAdd.vue");

const VistaEditarPerfilEmpresarial = () =>
  import("src/pages/views/perfilesEmpresariales/perfilEmpresarialEdit.vue");

//const VistaNuevoRol = () => import("src/pages/views/perfiles/perfilesAdd.vue");
const VistaNuevoRol = () =>
  import("src/pages/views/perfiles/perfilesAddEdit.vue");

const VistaRol = () => import("src/pages/views/perfiles/perfilesAdd.vue");

//const VistaEditarPerfil = () => import("src/pages/views/perfiles/perfilesEdit.vue");

const VistaNotificacionesWeb = () =>
  import("src/pages/views/notificacionesWeb/notificacionesWeb.vue");

const VistaPedidosDetalles = () =>
  import("src/pages/views/pedidos/pedidosDetails.vue");

const VistaPedidosDocumentos = () =>
  import("src/pages/views/pedidos/pedidosDocs.vue");

const VistaFacturas = () => import("src/pages/views/clientes/facturas.vue");

const VistaPedidosPartidas = () =>
  import("src/pages/views/pedidos/pedidosPartidas.vue");

const VistaTrackingPedido = () =>
  import("src/pages/views/pedidos/trackingPedido.vue");

const VistaEstadoCuentaCliente = () =>
  import("src/pages/views/clientes/estadoCuentaCliente.vue");
const VistaFasesEntrega = () =>
  import("src/pages/views/fasesEntrega/FasesEntregaMain.vue");
import("src/pages/views/clientes/estadoCuentaCliente.vue");

const DashboardReport = () =>
  import("src/pages/views/reportes/DashboardReport.vue");

const VistaReportePedidos = () =>
  import("src/pages/views/reportes/ReportePedidos");

const VistaReporteReclamaciones = () =>
  import("src/pages/views/reportes/ReporteReclamaciones");

const VistaReporteCotizaciones = () =>
  import("src/pages/views/reportes/ReporteCotizaciones");

const VistaEmpresasTransportistas = () =>
  import("src/pages/views/empresasTransportista/empresaTransportista.vue");

const VistaEstadoCuentaClientePDF = () =>
  import("src/pages/views/clientes/estadoCuentaClientePDF.vue");

const VistaUsuarioTransportistas = () =>
  import("src/pages/views/usuarioTransportista/usuariosTransportista.vue");

const VistaCambioPassword = () =>
  import("src/pages/views/publicViews/changePassword.vue");

const VistaOrganizaciones = () =>
  import("src/pages/views/organizaciones/organizaciones.vue");

const VistaCotizaciones = () =>
  import("src/pages/views/cotizacionesVendedor/cotizacionVendedor.vue");

const VistaEntregas = () => import("src/pages/views/entregas/entregas.vue");

const VistaEntregasCargaMasiva = () =>
  import("src/pages/views/entregas/entregasCargaMasiva.vue");

const VistaPedidoEmpresa = () =>
  import("src/pages/views/pedidos/pedidosEmpresa.vue");

const VistaEntregasOperadores = () =>
  import("src/pages/views/entregas/entregasOperadores.vue");

const VistaPaginaPermiso = () =>
  import("src/pages/views/publicViews/permissionRequire.vue");

const VistaIncidentes = () =>
  import("src/pages/views/incidencia/incidencia.vue");

const VistaMotivosDevolucion = () =>
  import("src/pages/views/motivosDevolucion/motivosDevolucion.vue");

const VistaFAQ = () =>
import("src/pages/views/FAQ/preguntas.vue");

const VistaContactoCliente = () =>
  import("src/pages/views/formularioCompra/contactosCorreos.vue");

const VistaUsuariosTransportistasCargaMasiva = () =>
  import("src/pages/views/usuarioTransportista/usuariosCargaMasiva.vue");
const VistaDesarrollador = () => import("src/pages/views/desarrollador/desarrolladorIndex.vue");

const VistaConsultaTrackingPedidos = () => import("src/pages/views/consultaTrackingPedidos/consultaTrackingPedidos.vue");

const VistaConfiguracionAsignacionesSAC = () => import("src/pages/views/configuracionAsignacionesSAC/configuracionAsignacionesSAC.vue");
const VistaConfiguracionAsignacionesLogistica = () => import("src/pages/views/configuracionAsignacionesLogistica/configuracionAsignacionesLogistica.vue");
const VistaSolicitudCambioCliente = () => import("src/pages/views/solicitudCambioInformacionCliente/solicitudCambioCliente.vue");

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons, header: DefaultHeader }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem, header: DefaultHeader }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels, header: DefaultHeader }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert, header: SweetAlertHeader }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications, header: DefaultHeader }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons, header: DefaultHeader }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography, header: DefaultHeader }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms, header: DefaultHeader }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms, header: DefaultHeader }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms, header: DefaultHeader }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard, header: DefaultHeader }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables, header: DefaultHeader }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables, header: DefaultHeader }
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      components: { default: PaginatedTables, header: DefaultHeader }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps, header: DefaultHeader }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps, header: VectorMapsHeader }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User, header: DefaultHeader }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine, header: DefaultHeader }
    }
  ]
};
let passChange = {
  path: "/",
  component: ChangePassLayout,
  name: "Change",
  children: [
    {
      path: "/password/:token/change",
      name: "Password",
      component: VistaCambioPassword
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/registro",
      name: "Registro",
      component: Registro
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    },
    {
      path: "/logout",
      name: "Logout",
      component: VistaLogout
    }
  ]
};
let viewPages = {
  path: "/admin",
  component: DashboarIndex,
  name: "Views",
  children: [
    {
      path: "roles",
      name: "Roles",
      components: { default: VistaPerfiles, header: DefaultHeader },
      meta: {
        controller: "Roles",
        action: "getAllRoles"
      }
    },
    {
      path: "roles_empresariales",
      name: "Roles empresariales",
      components: {
        default: VistaPerfilesEmpresariales,
        header: DefaultHeader
      },
      meta: {
        controller: "Roles",
        action: "rolesVista"
      }
    },
    {
      path: "roles_empresariales_nuevo",
      name: "Nuevo rol empresarial",
      components: {
        default: VistaNuevoPerfilEmpresarial,
        header: DefaultHeader
      },
      meta: {
        controller: "Roles",
        action: "postAddRolePermiso"
      }
    },
    {
      path: "roles_empresariales_editar",
      name: "Editar rol empresarial",
      components: {
        default: VistaEditarPerfilEmpresarial,
        header: DefaultHeader
      },
      meta: {
        controller: "Roles",
        action: "patchRolTraduccion"
      }
    },
    {
      path: "prospectos",
      name: "Prospectos",
      components: { default: VistaProspectos, header: DefaultHeader },
      meta: {
        controller: "Prospectos",
        action: "getProspectos"
      }
    },
    {
      path: "comunicados",
      name: "Comunicados",
      components: { default: VistaComunicados, header: DefaultHeader },
      meta: {
        controller: "Comunicaciones",
        action: "getComunicaciones"
      }
    },
    {
      path: "usuarios",
      name: "Usuarios",
      components: { default: VistaUsuarios, header: DefaultHeader },
      meta: {
        controller: "Usuarios",
        action: "getUsuarios"
      }
    },
    {
      path: "medidas",
      name: "Medidas",
      components: { default: VistaUnidadMedida, header: DefaultHeader },
      meta: {
        controller: "UnidadMedida",
        action: "getUnidadMedida"
      }
    },
    {
      path: "monedas",
      name: "Monedas",
      components: { default: VistaMonedas, header: DefaultHeader },
      meta: {
        controller: "TipoMoneda",
        action: "getTipoMoneda"
      }
    },
    {
      path: "notificaciones",
      name: "Notificaciones",
      components: { default: VistaNotificaciones, header: DefaultHeader },
      meta: {
        controller: "Notificaciones",
        action: "GetTiposNotificaciones"
      }
    },
    {
      path: "categorias",
      name: "Categorias",
      components: { default: VistaCategoriaProducto, header: DefaultHeader },
      meta: {
        controller: "CategoriaProducto",
        action: "getCategoria"
      }
    },
    {
      path: "subcategorias",
      name: "Sub categorias",
      components: { default: VistaSubcategoriaProducto, header: DefaultHeader },
      meta: {
        controller: "Subcategoria",
        action: "getSubcategoria"
      }
    },
    {
      path: "reclamaciones",
      name: "Reclamaciones",
      components: { default: VistaReclamaciones, header: DefaultHeader },
      meta: {
        controller: "Reclamaciones",
        action: "getReclamaciones"
      }
    },
    {
      path: "pedidos",
      name: "Pedidos",
      components: { default: VistaPedidos, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "ListaPedidos"
      }
    },
    {
      path: "pedidos/empresa/:clienteIdSap",
      name: "PedidosCliente",
      components: { default: VistaPedidoEmpresa, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "listaPedidosByIdSap"
      }
    },
    {
      path: "nuevo_pedido",
      name: "Nuevo Pedido",
      components: { default: VistaNuevoPedido, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "AddPedidoBunch"
      }
    },
    {
      path: "configuracion_email",
      name: "Configuración email",
      components: { default: VistaMailConfig, header: DefaultHeader },
      meta: {
        controller: "MailConfiguration",
        action: "getMailConfiguration"
      }
    },
    {
      path: "productos",
      name: "Productos",
      components: { default: VistaProductos, header: DefaultHeader },
      meta: {
        controller: "Productos",
        action: "getAllProductos"
      }
    },
    {
      path: "clientes",
      name: "Clientes",
      components: { default: VistaClientes, header: DefaultHeader },
      meta: {
        controller: "Clientes",
        action: "getListadoClientesSAP"
      }
    },
    {
      path: "caracteristicas_producto",
      name: "Caracteristicas Producto",
      components: {
        default: VistaCaracteristicaProducto,
        header: DefaultHeader
      },
      meta: {
        controller: "CaracteristicasProducto",
        action: "getCaratacteristicasProducto"
      }
    },
    {
      path: "tipos_documentos",
      name: "Tipos documentos",
      components: { default: VistaTiposDocumentos, header: DefaultHeader },
      meta: {
        controller: "TipoDocumentoPedido",
        action: "getTipoDocumentoPedido"
      }
    },
    {
      path: "motivos_declinacion",
      name: "Motivos declinacion",
      components: { default: VistaMotivosDeclinacion, header: DefaultHeader },
      meta: {
        controller: "DeclinacionPedido",
        action: "getDeclinacionPedido"
      }
    },
    {
      path: "tipos_incidencias",
      name: "Tipos Incidencias",
      components: { default: VistaIncidentes, header: DefaultHeader },
      meta: {
        controller: "Incidencia",
        action: "getTiposIncidencias"
      }
    },
    {
      path: "configuracion_notificaciones",
      name: "Configuracion notificaciones",
      components: {
        default: VistaConfiguracionNotificaciones,
        header: DefaultHeader
      },
      meta: {
        controller: "ConfiguracionNotificaciones",
        action: "getConfiguracionNotificaciones"
      }
    },
    {
      path: "horario_ingreso",
      name: "Horario ingreso",
      components: { default: VistaHorarioIngreso, header: DefaultHeader },
      meta: {
        controller: "HorarioIngresoPedido",
        action: "getHorarioIngresoPedido"
      }
    },
    {
      path: "familia_producto",
      name: "Familias productos",
      components: { default: VistaFamiliaProducto, header: DefaultHeader },
      meta: {
        controller: "FamiliasProducto",
        action: "getFamiliasProducto"
      }
    },
    {
      path: "nueva_familia_producto/:id?",
      name: "Nueva Familia de Productos",
      components: { default: VistaNuevaFamiliaProducto, header: DefaultHeader },
      meta: {
        controller: "FamiliasProducto",
        action: "addFamiliaProducto"
      }
    },
    {
      path: "propiedades_familias_producto",
      name: "Propiedades de familias de productos",
      components: {
        default: VistaPropiedadFamiliaProducto,
        header: DefaultHeader
      },
      meta: {
        controller: "PropiedadFamiliaProducto",
        action: "getPropiedadFamiliaProducto"
      }
    },
    {
      path: "nuevo_rol/:id?",
      name: "Nuevo Rol",
      components: { default: VistaNuevoRol, header: DefaultHeader },
      meta: {
        controller: "Roles",
        action: "addRole"
      }
    },
    {
      path: "roles",
      name: "Roles",
      components: { default: VistaRol, header: DefaultHeader },
      meta: {
        controller: "Roles",
        action: "getAllRoles"
      }
    },
    /*{
      path: "roles_editar",
      name: "Editar rol",
      components: { default: VistaEditarPerfil, header: DefaultHeader },
      meta: {
        controller: "Roles",
        action: "getAllRoles"
      }
    },*/
    {
      path: "notificaciones_web",
      name: "Notificaciones web",
      components: { default: VistaNotificacionesWeb, header: DefaultHeader },
      meta: {
        controller: "NotificacionWeb",
        action: "getNotificacionesWebHistorial"
      }
    },
    {
      path: "pedidos/:idPedido/detalle",
      name: "Detalle pedido",
      components: { default: VistaPedidosDetalles, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "ActualizarPedido"
      }
    },
    /*{
      path: "pedidos/:idPedido/documentos",
      name: "Documentos pedido",
      components: { default: VistaPedidosDocumentos, header: DefaultHeader }
    },*/
    {
      path: "facturas/:idClienteSAP",
      name: "Facturas cliente",
      components: { default: VistaFacturas, header: DefaultHeader },
      meta: {
        controller: "FacturacionCliente",
        action: "getFacturasCliente"
      }
    },
    {
      path: "pedidos/:idPedido/partidas",
      name: "Partidas pedido",
      components: { default: VistaPedidosPartidas, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "detallePedidoById"
      }
    },
    {
      path: "pedidos/:idPedido/tracking_pedido",
      name: "Tracking pedido",
      components: { default: VistaTrackingPedido, header: DefaultHeader },
      meta: {
        controller: "PartidaTracking",
        action: "getTrackingPartida"
      }
    },
    {
      path: "estado_cuenta_cliente/:idClienteSAP",
      name: "Estado cuenta cliente",
      components: { default: VistaEstadoCuentaCliente, header: DefaultHeader },
      meta: {
        controller: "EstadoCuenta",
        action: "getEstadosCuentaCliente"
      }
    },
    {
      path: "reporte_pedidos",
      name: "Reporte pedidos",
      components: { default: VistaReportePedidos, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "ListaPedidos"
      }
    },
    {
      path: "reporte_reclamaciones",
      name: "Reporte reclamaciones",
      components: { default: VistaReporteReclamaciones, header: DefaultHeader },
      meta: {
        controller: "Reclamaciones",
        action: "getReclamaciones"
      }
    },
    {
      path: "reporte_cotizaciones",
      name: "Reporte cotizaciones",
      components: { default: VistaReporteCotizaciones, header: DefaultHeader },
      meta: {
        controller: "Cotizacion",
        action: "listaCotizaciones"
      }
    },
    {
      path: "estado_cuenta_cliente_pdf",
      name: "Estado cuenta cliente pdf",
      components: {
        default: VistaEstadoCuentaClientePDF,
        header: DefaultHeader
      },
      meta: {
        controller: "EstadoCuenta",
        action: "getEstadosCuentaCliente"
      }
    },
    {
      path: "empresas_transportistas",
      name: "Empresas Transportistas",
      components: {
        default: VistaEmpresasTransportistas,
        header: DefaultHeader
      },
      meta: {
        controller: "EmpresaTransportista",
        action: "getEmpresasTransportistas"
      }
    },
    {
      path: "usuarios_transportistas",
      name: "Usuarios Transportistas",
      components: {
        default: VistaUsuarioTransportistas,
        header: DefaultHeader
      },
      meta: {
        controller: "UsuarioTransportista",
        action: "getUsuariosTransportistas"
      }
    },
    {
      path: "delivery_phases",
      name: "Fases Entrega",
      components: { default: VistaFasesEntrega, header: DefaultHeader },
      meta: {
        controller: "GrupoConfiguracionFasesEntrega",
        action: "getConfigFasesDeEntrega"
      }
    },
    {
      path: "organizaciones",
      name: "Organizaciones",
      components: { default: VistaOrganizaciones, header: DefaultHeader },
      meta: {
        controller: "Organizaciones",
        action: "listaOrganizaciones"
      }
    },
    {
      path: "entregas",
      name: "Entregas",
      components: { default: VistaEntregas, header: DefaultHeader },
      meta: {
        controller: "Pedidos",
        action: "ListaPedidoPorTransportista"
      }
    },
    {
      path: "entregas_carga_masiva",
      name: "Entregas carga masiva",
      components: { default: VistaEntregasCargaMasiva, header: DefaultHeader },
      meta: {
        controller: "PartidaTracking",
        action: "getTrakingLayout"
      }
    },
    {
      path: "motivivos_devolucion",
      name: "Motivos devolucion",
      components: { default: VistaMotivosDevolucion, header: DefaultHeader },
      meta: {
        controller: "TiposMotivoRechazo",
        action: "getMotivosRechazoPartida"
      }
    },
    {
      path: "faq",
      name: "Preguntas Frecuentes",
      components: { default: VistaFAQ, header: DefaultHeader },
      meta: {
        controller: "FAQ",
        action: "getPreguntas"
      }
    },
    {
      path: "cotizaciones",
      name: "Cotizaciones",
      components: { default: VistaCotizaciones, header: DefaultHeader },
      meta: {
        controller: "Cotizacion",
        action: "listaCotizacionesByVendedor"
      }
    },
    {
      path: "verificar_permiso",
      name: "Verificar permiso",
      components: { default: VistaPaginaPermiso, header: DefaultHeader }
    },
    {
      path: "compra_rapida",
      name: "Compra rapida",
      components: { default: VistaContactoCliente, header: DefaultHeader },
      meta: {
        controller: "Clientes",
        action: "getListadoClientesAndContactosSAP"
      }
    },
    {
      path: "entregas_operador",
      name: "entregas operadores",
      components: { default: VistaEntregasOperadores, header: DefaultHeader }
      /*meta: {
        controller: "Clientes",
        action: "getListadoClientesAndContactosSAP"
      }*/
    },
    {
      path: "usuarios_transportistas_carga_masiva",
      name: "Usuarios Transportistas carga masiva",
      components: { default: VistaUsuariosTransportistasCargaMasiva, header: DefaultHeader },
      meta: {
        controller: "PartidaTracking",
        action: "getTrakingLayout"
      }
    },
    {
      path: "configuracion_asignaciones_sac",
      name: "Configuracion asignaciones SAC",
      components: { default: VistaConfiguracionAsignacionesSAC, header: DefaultHeader },
      /*meta: {
        controller: "FamiliasProducto",
        action: "getFamiliasProducto"
      }*/
    },
    {
      path: "configuracion_asignaciones_logistica",
      name: "Configuracion asignaciones logistica",
      components: { default: VistaConfiguracionAsignacionesLogistica, header: DefaultHeader },
      /*meta: {
        controller: "FamiliasProducto",
        action: "getFamiliasProducto"
      }*/
    },
    {
      path: "solicitud_cambio_cliente",
      name: "Solicitud cambio cliente",
      components: { default: VistaSolicitudCambioCliente, header: DefaultHeader },
      /*meta: {
        controller: "FamiliasProducto",
        action: "getFamiliasProducto"
      }*/
    },
    {
      path: "desarrollador",
      name: "Desarrollador",
      components: { default: VistaDesarrollador, header: DefaultHeader },
      meta: {
        controller: "WebServiceTransportistas",
        action: "addTracking"
      }
    },
    {
      path: "consulta_tracking_pedidos",
      name: "Consulta tracking pedidos",
      components: { default: VistaConsultaTrackingPedidos, header: DefaultHeader },
      meta: {
        controller: "WebServiceTransportistas",
        action: "addTracking"
      }
    },
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  viewPages,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  passChange,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: DashboardReport, header: DashboardHeader },
        meta: {
          controller: "Reportes",
          action: "getTotalPedidosByStatus"
        }
      }
      /*{
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar, header: CalendarHeader }
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts, header: DefaultHeader }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets, header: DefaultHeader }
      }*/
    ]
  },
  { path: "*", component: NotFound }
];

export default routes;
